// English language pack
export default {
  settings: {
    title: 'Settings',
    hourFormat: 'Hour Format',
    scale: 'Scale',
    brightness: 'Brightness',
    background: 'Background',
    language: 'Language',
    showSeconds: 'Show Seconds',
    pomodoro: 'Pomodoro Settings'
  },
  timer: {
    stopwatch: 'Stopwatch',
    timer: 'Timer',
    pomodoro: 'Pomodoro',
    customTimer: 'Custom Timer',
    start: 'Start',
    pause: 'Pause',
    reset: 'Reset',
    stop: 'Stop',
    shortBreak: 'Short Break',
    longBreak: 'Long Break',
    sessionsBeforeLongBreak: 'Sessions Before Long Break'
  },
  pomodoro: {
    title: 'Pomodoro Focus',
    workTime: 'Focus Time',
    breakTime: 'Break Time',
    longBreakTime: 'Long Break',
    completedToday: 'Today',
    totalCompleted: 'Total',
    currentStreak: 'Streak',
    addNote: 'Add Note',
    viewStats: 'View Stats',
    exportData: 'Export',
    importData: 'Import',
    dataPanel: 'Data Panel'
  },
  stats: {
    title: 'Statistics',
    today: 'Today',
    thisWeek: 'This Week',
    thisMonth: 'This Month',
    total: 'Total',
    pomodoroCount: 'Pomodoros',
    focusTime: 'Focus Time',
    avgPerDay: 'Avg/Day',
    chart: 'Trend Chart',
    noData: 'No Data'
  },
  common: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    close: 'Close',
    export: 'Export',
    import: 'Import',
    success: 'Success',
    error: 'Error',
    default: 'Default'
  },
  format: {
    hour12: '12h',
    hour24: '24h'
  }
}
